var exports = {
  "S": "dashedButton__Bcr4KC",
  "M": "hotkeyBadge__TT0GnF",
};

module.exports = exports;
